import styled, { keyframes } from 'styled-components';
import { getScrollBarStyles } from '../../../config/styles';
import { theme } from '../../../styles/theme';
import { SecondaryButton } from '../../Button';
import { TextAreaField } from '../../Form';
import { SvgIcon } from '../../Icon';

export const Card = styled.div`
  background: ${theme.colors.level1};
  border: 1px solid ${theme.colors.border};
  border-radius: 8px;
  margin: 16px 24px 4px 24px;
  width: fit-content;
  min-width: 640px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 0 20px;
`;

export const ContentRow = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  border-radius: 4px;
  margin: 16px;
  padding: 0;
  min-height: 40px;
  max-height: 80px;
  max-width: 100%;
`;

export const BuildButton = styled(SecondaryButton)`
  background: ${theme.colors.purple500};
  color: ${theme.colors.white};
  border: none;
  min-height: 100%;
  font-weight: 500;
  font-size: 14px;
  min-width: 162px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: none;

  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

  &:hover:not(:disabled) {
    background: ${theme.colors.purple500};
    color: ${theme.colors.white};
  }
`;

export const StyledTextArea = styled(TextAreaField)`
  border: none;
  box-shadow: none;
  background: ${theme.colors.secondary300};
  font-size: 14px;
  color: ${theme.colors.secondary900};
  font-weight: 400;
  padding: 12px 16px;
  width: calc(100% - 162px);
  height: 100%;
  min-height: 40px;
  max-height: 80px;
  overflow-y: auto;
  resize: none;
  font-family: inherit;
  &::placeholder {
    color: ${theme.colors.secondary400};
    opacity: 1;
    line-height: 1.2;
  }

  border-top-right-radius: 0;
  border-bottom-right-radius: 0;

  ${getScrollBarStyles(4)}
`;

export const shimmerAnimation = keyframes`
  0% {
    background-position: -100% 0;
  }
  100% {
    background-position: 100% 0;
  }
`;

export const spinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const InputLoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 16px;
  background: ${theme.colors.secondary300};
  width: 100%;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
`;

export const InputLoadingText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${theme.colors.purple500};
`;

export const ButtonLoadingContainer = styled.div`
  background: linear-gradient(
    90deg,
    ${theme.colors.purple400} 0%,
    ${theme.colors.purple400} 20%,
    ${theme.colors.purple500} 40%,
    ${theme.colors.purple500} 60%,
    ${theme.colors.purple400} 80%,
    ${theme.colors.purple400} 100%
  );
  background-size: 200% 100%;
  color: ${theme.colors.white};
  height: 100%;
  font-weight: 500;
  font-size: 14px;
  min-width: 162px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  animation: ${shimmerAnimation} 3s linear infinite;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  padding: 0 16px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const ButtonLoadingText = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SpinningIcon = styled(SvgIcon)`
  animation: ${spinAnimation} 1s linear infinite;
`;
